import { render, staticRenderFns } from "./AssTipoVisitaAssuntoVisitaModal.vue?vue&type=template&id=7458f0b9&scoped=true"
import script from "./AssTipoVisitaAssuntoVisitaModal.vue?vue&type=script&lang=js"
export * from "./AssTipoVisitaAssuntoVisitaModal.vue?vue&type=script&lang=js"
import style0 from "./AssTipoVisitaAssuntoVisitaModal.vue?vue&type=style&index=0&id=7458f0b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458f0b9",
  null
  
)

export default component.exports